import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import { Biller, BillerGroup } from "model";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function MoveBillerToGroupModal
 * @param {STRING} billerName - This sets the name of the biller.
 * @param {STRING} accountLastFour - This sets the last four of the account number for the biller.
 * @param {STRING} billerGroup - This sets the name of the biller group.
 * @returns {React.Component}
 * @exported true
 * @description This is the modal that shows when you move a biller between biller groups.
 * @example
 * <MoveBillerToGroupModal />
 */
export default function MoveBillerToGroupModal(props) {
  const { close } = useBCMSModal();
  const data = props.data ?? {};

  // Temporary solution for opening a modal
  // and needing to show a Biller and BillerGroup since they are class types.
  const billerID = data.billerID ?? "";
  const billerGroupID = data.billerGroupToID ?? "";
  const biller = Biller.initByID(billerID);
  const billerGroupTo = BillerGroup.initByID(billerGroupID) === undefined ? { name: "Other billers" } : BillerGroup.initByID(billerGroupID);
  const billerName = biller.name;
  const billerNumber = biller.number;
  const billerGroupToName = billerGroupTo.name;

  const onClick = () => {
    props.data.onMoveGroupButtonModalClick(props.data);
    close("MoveBillerToGroupModal");
  }

  return(
    <CustomModal id="MoveBillerToGroupModal" className="move-biller-to-group-modal large-icon-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
      <div className="set-width">
          <SVGAsset id="UpsellIcon" className="info-icon left-icon" />
        </div>
        <div className="flex-width">
          <h4 className="modal-title"><b>Move biller to new group</b></h4>
          <p className="sub-text">Are you sure you want to move <b>{ billerName } { billerNumber }</b> to <b>{ billerGroupToName }</b>?</p>
        </div>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container">
        <ModalCloseButton text="Cancel" id="MoveBillerToGroupModal" />
        <ModalPrimaryButton text="Move" onClick={ onClick } dataPoint="Move_Biller_Group_Confirm" />
      </CustomModalFooter>
    </CustomModal>
  );
}